module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};


//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/core-js/2.4.1/core-js/library/modules/_a-function.js
// module id = 63
// module chunks = 0